import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueSweetAlert from 'vue-sweetalert'
import App from './App'
import router from './router'
// import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'babel-polyfill'
import store from './store/index.js'
import moment from 'moment'

Vue.config.productionTip = false

Vue.use(VeeValidate)
Vue.use(VueSweetAlert)
Vue.use(Vuetify)

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

// Date filter

Vue.filter('yearFormat', function (value) {
  return moment(value).year()
})
Vue.filter('longMonthYearFormat', function (value) {
  return moment(value, 'DD/MM/YY').format('MMMM YYYY')
})

Vue.filter('dateTimeFormat', function (value) {
  return moment(value).date() + '/' + moment(value).month() + '/' +
    moment(value).year() + ' ' + moment(value).hours() + ':' +
    moment(value).minute() + ':' + moment(value).second()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    app: App
  },
  render: h => h('app')
})



// WEBPACK FOOTER //
// ./src/main.js